/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "key-modern-inline-1ceecce3--sprite",
  "use": "key-modern-inline-1ceecce3--sprite-usage",
  "viewBox": "0 0 36.01 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.01 36\" id=\"key-modern-inline-1ceecce3--sprite\"><g transform=\"translate(-915.254 -1639)\"><g opacity=\"0\"><path d=\"M933.185,1639a18,18,0,0,1,18.079,17.921h0A18,18,0,0,1,933.343,1675h0a18,18,0,0,1-18.079-17.92V1657a17.961,17.961,0,0,1,17.921-18Z\" fill=\"#fcf8d0\" /></g></g><path d=\"M33.869,6.257H16.953a2.729,2.729,0,0,1-1.893-.738L10.121.766A2.64,2.64,0,0,0,8.227,0H2.355C.873,0,0,6.655,0,8.08V9.321c0,1.426.873,8.133,2.355,8.133H8.227a2.643,2.643,0,0,0,1.894-.765l5.021-4.806a2.689,2.689,0,0,1,1.893-.767H28.243v1.057A1.863,1.863,0,0,0,30.138,14h1.234a1.855,1.855,0,0,0,1.866-1.821V11.117h.631a1.884,1.884,0,0,0,1.92-1.822V8.08A1.869,1.869,0,0,0,33.869,6.257ZM6.2,9.321a1.6,1.6,0,0,1-1.646,1.559A1.593,1.593,0,0,1,2.931,9.321V7.6A1.633,1.633,0,0,1,6.2,7.6Z\" transform=\"translate(0 9.252)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
